module.exports = __webpack_public_path__ + "static/img/market.1795b93b.svg";